var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWentWellLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E5F3E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#went-well-like_svg__clip0_4493_171834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2 10.8V10h.031a4.637 4.637 0 01.293.015c.186.014.444.043.733.1.547.11 1.339.35 1.909.92 1.035 1.034 1.034 2.124 1.034 2.932V15.6h2.4c.576 0 1.172.197 1.634.61.475.425.766 1.045.766 1.79a.793.793 0 01-.01.131l-.8 4.8a.778.778 0 01-.014.063C24.71 24.864 23.25 26 22 26h-5.6a.8.8 0 01-.566-.234L14.8 24.73v.469a.8.8 0 01-.8.8h-3.2a.8.8 0 01-.8-.8v-8a.8.8 0 01.8-.8H14a.8.8 0 01.794.7l.025-.02c.2-.146.455-.364.704-.628.532-.566.877-1.171.877-1.652v-4a.8.8 0 01.8-.8v.8zm-2.4 8v3.669l1.931 1.931H22c.348 0 1.277-.456 1.616-1.765l.783-4.693c-.013-.271-.116-.436-.233-.54a.854.854 0 00-.566-.202h-3.2a.8.8 0 01-.8-.8V14c0-.788-.014-1.283-.566-1.834-.22-.22-.604-.377-1.034-.47V14.8c0 1.12-.715 2.114-1.313 2.748a6.971 6.971 0 01-.92.822c-.137.1-.273.19-.396.258-.061.034-.132.07-.206.099a1.005 1.005 0 01-.365.073zm-1.6-.8h-1.6v6.4h1.6V18z",
    fill: "#14454C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "went-well-like_svg__clip0_4493_171834"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "fonts/went-well-like-39b249cc38ba5aae77a35ad5d510b42e.svg";
export { SvgWentWellLike as ReactComponent };